// extracted by mini-css-extract-plugin
export default {"warning":"PaperClip_warning__NUXYt"};